import { Done } from "@mui/icons-material"

export function StepsBar({ mounted, pageNum }) {
  return (
    <div
      className={`${
        mounted ? "translate-x-0" : "translate-x-[-100%]"
      } transition-transform duration-500 bg-blue h-screen px-7 py-24 w-[360px] hidden sm:flex sm:flex-col`}
    >
      <div>
        <img src='./assets/logo/logo.svg' alt='logo' />
      </div>
      <p className='text-white text-2xl font-medium mt-7'>Регистрация</p>

      <div className='mt-11'>
        <div className='flex w-fit'>
          <div className='flex flex-col items-center'>
            <span className={`circle ${pageNum >= 1 && "bg-white"}`}>
              <span
                className={`dot ${
                  pageNum === 1 ? "bg-orange" : "bg-transparent"
                } flex items-center justify-center`}
              >
                {pageNum > 1 && (
                  <Done
                    fontSize='large'
                    color='secondary'
                    sx={{ fontWeight: "500", width: "18px" }}
                  />
                )}
              </span>
            </span>
            <p className='line'>
              <span
                className={`subline rounded-[50px] ${
                  pageNum > 1 && "sublineActive"
                }`}
              ></span>
            </p>
          </div>

          <div className='flex flex-col ml-3 justify-center h-fit mt-1'>
            <p className={`${pageNum >= 1 ? "text-white" : "text-gray"}  `}>
              Персональные данные
            </p>
          </div>
        </div>

        <div className='flex w-fit'>
          <div className='flex flex-col items-center'>
            <span className={`circle ${pageNum >= 2 && "bg-white"}`}>
              <span
                className={`dot ${
                  pageNum < 2
                    ? "bg-white"
                    : pageNum === 2
                    ? "bg-orange"
                    : "bg-transparent"
                } flex items-center justify-center`}
              >
                {pageNum > 2 && (
                  <Done
                    fontSize='large'
                    color='secondary'
                    sx={{ fontWeight: "500", width: "18px" }}
                  />
                )}
              </span>
            </span>
            <p className='line'>
              <span
                className={`subline rounded-[50px] ${
                  pageNum > 2 && "sublineActive"
                }`}
              ></span>
            </p>
          </div>

          <div className='flex flex-col ml-3 justify-center h-fit mt-1 whitespace-nowrap overflow-hidden text-ellipsis'>
            <p className={`${pageNum >= 2 ? "text-white" : "text-gray"} `}>
              Код подтверждения
            </p>
          </div>
        </div>

        <div className='flex w-fit'>
          <div className='flex flex-col items-center'>
            <span
              className={`circle ${
                pageNum >= 3 ? "bg-white" : "bg-transparent"
              }`}
            >
              <span
                className={`dot ${
                  pageNum < 3
                    ? "bg-white"
                    : pageNum === 3
                    ? "bg-orange"
                    : "bg-transparent"
                } flex items-center justify-center`}
              >
                {pageNum > 3 && (
                  <Done
                    fontSize='large'
                    color='secondary'
                    sx={{ fontWeight: "500", width: "18px" }}
                  />
                )}
              </span>
            </span>
            <p className='line'>
              <span
                className={`subline rounded-[50px] ${
                  pageNum > 3 && "sublineActive"
                }`}
              ></span>
            </p>
          </div>

          <div className='flex flex-col ml-3 justify-center h-fit mt-1'>
            <p className={`${pageNum >= 3 ? "text-white" : "text-gray"}`}>
              Введите новый пароль
            </p>
          </div>
        </div>

        <div className='flex w-fit'>
          <div className='flex flex-col items-center'>
            <span className={`circle ${pageNum >= 4 && "bg-white"}`}>
              <span
                className={`dot ${
                  pageNum < 4
                    ? "bg-white"
                    : pageNum === 4
                    ? "bg-orange"
                    : "bg-transparent"
                } flex items-center justify-center`}
              >
                {pageNum > 4 && (
                  <Done
                    fontSize='large'
                    color='secondary'
                    sx={{ fontWeight: "500", width: "18px" }}
                  />
                )}
              </span>
            </span>
            <p className='line'>
              <span
                className={`subline rounded-[50px] ${
                  pageNum > 4 && "sublineActive"
                }`}
              ></span>
            </p>
          </div>

          <div className='flex flex-col ml-3 justify-center h-fit mt-1'>
            <p className={`${pageNum >= 4 ? "text-white" : "text-gray"}`}>
              Выберите тип аккаунта
            </p>
          </div>
        </div>

        <div className='flex w-fit'>
          <div className='flex flex-col items-center'>
            <span className={`circle ${pageNum >= 5 && "bg-white"}`}>
              <span
                className={`dot ${
                  pageNum < 5
                    ? "bg-white"
                    : pageNum === 5
                    ? "bg-orange"
                    : "bg-transparent"
                } flex items-center justify-center`}
              >
                {pageNum > 5 && (
                  <Done
                    fontSize='large'
                    color='secondary'
                    sx={{ fontWeight: "500", width: "18px" }}
                  />
                )}
              </span>
            </span>
          </div>

          <div className='flex flex-col ml-3 justify-center h-fit mt-1'>
            <p className={`${pageNum >= 5 ? "text-white" : "text-gray"}`}>
              Выберите сферу деятельности
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}